(function () {
  'use strict';
  var B = window.BRKN || { routes: {} };
  var R = B.routes || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clean(t) { return String(t || '').replace(/["\u201c\u201d]/g, ''); }
  function img(u, w) { if (!u) return ''; if (typeof u === 'object') u = u.url || u.src || ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function money(c) {
    c = Number(c) || 0;
    var fmt = B.moneyFormat || '$' + '{{amount}}';
    var a = (c / 100).toFixed(2), nd = String(Math.round(c / 100)), s = a.replace(/\.00$/, '');
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return nd;
      if (k === 'amount_with_comma_separator') return a.replace('.', ',');
      return s;
    });
  }
  function getJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };

  /* ---------- drawers ---------- */
  var openEl = null, lastFocus = null;
  function openDrawer(name) {
    var el = document.querySelector('[data-drawer="' + name + '"]');
    if (!el) return false;
    closeAll(true);
    lastFocus = document.activeElement;
    el.hidden = false; openEl = el;
    document.body.classList.add('lock');
    setTimeout(function () {
      var f = name === 'search' ? $('[data-search-input]', el) : $('[data-close]', el);
      if (f) f.focus();
    }, 30);
    if (name === 'cart') renderCart();
    return true;
  }
  function closeAll(silent) {
    $$('[data-drawer]').forEach(function (d) { d.hidden = true; });
    if (!popOpen()) document.body.classList.remove('lock');
    if (openEl && lastFocus && !silent) { try { lastFocus.focus(); } catch (e) {} }
    openEl = null;
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      var n = o.getAttribute('data-open');
      if (n === 'size') {
        var d = document.getElementById('size-chart');
        if (d) { d.open = true; window.scrollTo({ top: d.getBoundingClientRect().top + window.scrollY - 150, behavior: 'smooth' }); }
        e.preventDefault(); return;
      }
      if (n === 'cart' && B.tpl === 'cart') return;
      if (openDrawer(n)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-open-popup]')) { e.preventDefault(); showPopup(true); return; }
    var c = e.target.closest('[data-close]');
    if (c) {
      e.preventDefault();
      if (c.closest('[data-popup]')) closePopup(); else closeAll();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closePopup(); } });

  /* ---------- header hide on scroll (phones) ---------- */
  var hdr = $('[data-header]'), hwrap = hdr ? (hdr.closest('.shopify-section') || hdr) : null, lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    if (!hwrap) return;
    var y = window.scrollY, d = y - lastY;
    if (Math.abs(d) < 8) return;
    hwrap.classList.toggle('is-hidden', isMobile() && d > 0 && y > 160 && !openEl);
    lastY = y;
  }, { passive: true });

  /* ---------- cart ---------- */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function renderCart(cart) {
    var p = cart ? Promise.resolve(cart) : getJSON(R.cart + '.js');
    return p.then(function (c) {
      setCount(c.item_count);
      var items = $('[data-cart-items]'), foot = $('[data-cart-foot]'), ship = $('[data-ship]'), empty = $('[data-cart-empty]'), nudge = $('[data-nudge]');
      if (!items) return c;
      var t = B.freeShip || 0, left = t - c.total_price, g = B.gift || {};
      var sh = '';
      if (t) sh += '<span>' + (left > 0 ? 'YOU\u2019RE ' + money(left) + ' AWAY FROM FREE SHIPPING' : 'FREE SHIPPING UNLOCKED') + '</span><div class="ship__bar"><span style="width:' + Math.min(100, Math.round(c.total_price / t * 100)) + '%"></span></div>';
      if (g.at) sh += '<span class="cartd__gift' + (c.total_price >= g.at ? ' is-on' : '') + '">' + esc(g.name || 'MYSTERY GIFT') + (c.total_price >= g.at ? ' UNLOCKED' : ' ' + money(g.at) + '+') + '</span>';
      if (ship) { ship.innerHTML = sh; ship.hidden = !sh || !c.item_count; }
      if (!c.item_count) {
        items.innerHTML = ''; if (empty) empty.hidden = false; if (foot) foot.hidden = true; if (nudge) nudge.hidden = true; return c;
      }
      if (empty) empty.hidden = true; if (foot) foot.hidden = false;
      if (nudge) nudge.hidden = !(t && left > 0);
      items.innerHTML = c.items.map(function (it, i) {
        var meta = [];
        if (it.variant_title && it.variant_title !== 'Default Title') meta.push(esc(it.variant_title));
        if (it.properties) Object.keys(it.properties).forEach(function (k) { if (k.charAt(0) !== '_' && it.properties[k]) meta.push(esc(k) + ': ' + esc(it.properties[k])); });
        var line = i + 1;
        return '<div class="li"><a class="li__img" href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image, 240) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="li__info"><a class="li__t" href="' + it.url + '">' + esc(clean(it.product_title)) + '</a>' + (meta.length ? '<span class="li__m">' + meta.join(' · ') + '</span>' : '') +
          '<div class="qty"><button type="button" data-q="' + line + '" data-n="' + (it.quantity - 1) + '" aria-label="Decrease quantity">\u2212</button><span>' + it.quantity + '</span><button type="button" data-q="' + line + '" data-n="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
          '<span class="li__p">' + money(it.final_line_price) + '</span></div>';
      }).join('');
      var tot = $('[data-cart-total]'); if (tot) tot.textContent = money(c.total_price);
      syncNudge(c);
      return c;
    });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]'); if (!q) return;
    e.preventDefault(); q.disabled = true;
    getJSON(R.cart_change + '.js', { method: 'POST', body: JSON.stringify({ line: Number(q.getAttribute('data-q')), quantity: Math.max(0, Number(q.getAttribute('data-n'))) }) })
      .then(function (c) { renderCart(c); })
      .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Could not update the cart.'); renderCart(); });
  });
  /* quick add (cards, nudge) */
  function addVariant(id, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('data-l', btn.textContent); btn.textContent = '\u2026'; }
    return getJSON(R.cart_add + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function () { return renderCart(); })
      .then(function () { if (!(openEl && openEl.getAttribute('data-drawer') === 'cart')) openDrawer('cart'); })
      .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-l'); } });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-quick-add]');
    if (a) {
      e.preventDefault();
      var card = a.closest('[data-card]'); var sz = card && $('[data-quick-sizes]', card);
      addVariant(a.getAttribute('data-quick-add'), a).then(function () { if (sz) { sz.hidden = true; var pl = $('[data-quick-open]', card); if (pl) pl.hidden = false; } });
      return;
    }
    var o = e.target.closest('[data-quick-open]');
    if (o) { e.preventDefault(); var c = o.closest('[data-card]'); $$('[data-quick-sizes]').forEach(function (s) { s.hidden = true; }); $$('[data-quick-open]').forEach(function (b) { b.hidden = false; }); $('[data-quick-sizes]', c).hidden = false; o.hidden = true; return; }
    var x = e.target.closest('[data-quick-close]');
    if (x) { e.preventDefault(); var cc = x.closest('[data-card]'); $('[data-quick-sizes]', cc).hidden = true; $('[data-quick-open]', cc).hidden = false; }
  });

  /* ---------- product page ---------- */
  function initPDP(root) {
    var dataEl = $('[data-product-json]', root); if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var V = data.variants || [];
    var form = root.querySelector('form[action*="/cart/add"]'); if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var sets = $$('[data-opt]', root);
    var add = $('[data-add]', root), low = $('[data-low]', root), price = $('[data-price]', root), err = $('[data-err]', root), status = $('[data-status]', root);
    var addPrice = $('[data-add-price]', root), sold = $('[data-soldout]', root), pay = $('[data-pay]', root);
    var sticky = $('[data-sticky]', root), sAdd = $('[data-sticky-add]', root), sSizes = $$('[data-sticky-size]', root);
    var sizeSet = data.sizeIdx > -1 ? sets[data.sizeIdx] : null;
    function sel() { return sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function match(s) { return V.filter(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); })[0]; }
    function update(push) {
      var s = sel(), v = sets.length ? match(s) : V[0];
      sets.forEach(function (fs, oi) {
        $$('label.sz', fs).forEach(function (lab) {
          var s2 = s.slice(); s2[oi] = lab.querySelector('input').value;
          var m = match(s2); lab.classList.toggle('is-out', !m || !m.available);
        });
      });
      sSizes.forEach(function (b) {
        var s2 = s.slice(); s2[data.sizeIdx] = b.getAttribute('data-sticky-size'); var m = match(s2);
        b.classList.toggle('is-out', !m || !m.available); b.classList.toggle('is-on', s[data.sizeIdx] === b.getAttribute('data-sticky-size'));
      });
      var ok = !!(v && v.available);
      add.hidden = !ok; if (sold) sold.hidden = ok; if (pay) pay.hidden = !ok;
      if (status) status.textContent = v && !v.available ? 'SOLD OUT' : '';
      if (sAdd) { sAdd.disabled = !ok; sAdd.textContent = ok ? 'ADD \u00b7 ' + money(v.price) : 'SOLD OUT'; }
      if (!v) { low.hidden = true; return; }
      idInput.value = v.id;
      if (addPrice) addPrice.textContent = money(v.price);
      price.innerHTML = v.compare > v.price ? '<s>' + money(v.compare) + '</s> <span class="sale">' + money(v.price) + '</span> <span class="save">SAVE ' + money(v.compare - v.price) + '</span>' : money(v.price);
      var th = data.low || 3;
      if (v.available && v.qty !== null && v.qty > 0 && v.qty <= th) {
        low.textContent = 'ONLY ' + v.qty + ' LEFT' + (data.sizeIdx > -1 && V.length > 1 ? ' IN ' + String(v.options[data.sizeIdx]).toUpperCase() : '');
        low.hidden = false;
      } else low.hidden = true;
      if (push && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }
    sets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
    sSizes.forEach(function (b) { b.addEventListener('click', function () {
      if (!sizeSet) return; var val = b.getAttribute('data-sticky-size');
      $$('input', sizeSet).forEach(function (i) { if (i.value === val) i.checked = true; }); update(true);
    }); });
    if (sAdd) sAdd.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(add); else add.click(); });
    update(false);
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      err.hidden = true;
      var lab = $('[data-add-label]', add); var t0 = lab ? lab.textContent : '';
      add.disabled = true; if (lab) lab.textContent = 'ADDING\u2026';
      fetch(R.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { add.disabled = false; if (lab) lab.textContent = t0; return renderCart().then(function () { openDrawer('cart'); }); })
        .catch(function (j) { add.disabled = false; if (lab) lab.textContent = t0; err.textContent = (j && (j.description || j.message)) || 'Could not add to cart.'; err.hidden = false; });
    });
    /* gallery: dots + thumbs */
    var track = $('[data-track]', root), dots = $$('.pdp__dots span', root), thumbs = $$('[data-thumb]', root);
    if (track && dots.length) track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () {
      var k = b.getAttribute('data-thumb'), el = document.getElementById('pd-img-' + k);
      thumbs.forEach(function (x) { x.classList.toggle('is-on', x === b); });
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 140, behavior: 'smooth' });
    }); });
    /* tabs */
    var tabsWrap = $('[data-tabs]', root);
    function showTab(name) {
      if (!tabsWrap) return;
      $$('[data-tab]', tabsWrap).forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tab') === name ? 'true' : 'false'); });
      $$('[data-panel]', tabsWrap).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== name; });
    }
    if (tabsWrap) $$('[data-tab]', tabsWrap).forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-tab')); }); });
    $$('[data-tab-open]', root).forEach(function (b) { b.addEventListener('click', function () { showTab(b.getAttribute('data-tab-open')); if (tabsWrap) window.scrollTo({ top: tabsWrap.getBoundingClientRect().top + window.scrollY - 150, behavior: 'smooth' }); }); });
    /* sticky add bar (phones) */
    if (sticky && add) {
      var onS = function () {
        var b = add.getBoundingClientRect(), on = isMobile() && !add.hidden && b.bottom < 0;
        if (sticky.hidden === on) { sticky.hidden = !on; document.body.classList.toggle('has-sticky', on); }
      };
      window.addEventListener('scroll', onS, { passive: true }); window.addEventListener('resize', onS); onS();
    }
    try {
      var h = root.getAttribute('data-handle'), list = JSON.parse(localStorage.getItem('brkn_recent') || '[]').filter(function (x) { return x !== h; });
      list.unshift(h); localStorage.setItem('brkn_recent', JSON.stringify(list.slice(0, 9)));
    } catch (e) {}
  }

  function cardHTML(p) {
    var t = esc(clean(p.title)), out = !p.available;
    var pr = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s><span class="sale">' + money(p.price) + '</span>' : '<span>' + money(p.price) + '</span>';
    return '<div class="card' + (out ? ' is-out' : '') + '" data-card><div class="card__media"><a class="card__link" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
      (p.featured_image ? '<img class="card__img" src="' + img(p.featured_image, 700) + '" alt="' + t + '" loading="lazy">' : '') + '</a>' +
      (out ? '<span class="card__out">SOLD OUT</span>' : '') +
      '</div><a class="card__info" href="' + p.url + '"><span class="card__title">' + t + '</span><span class="card__price">' + pr + '</span></a></div>';
  }
  function initRecent() {
    var sec = $('[data-recent]'); if (!sec) return;
    var cur = sec.getAttribute('data-current'), list = [];
    try { list = JSON.parse(localStorage.getItem('brkn_recent') || '[]'); } catch (e) {}
    list = list.filter(function (h) { return h && h !== cur; }).slice(0, 4);
    if (!list.length) return;
    var base = (R.root || '/').replace(/\/$/, '');
    Promise.all(list.map(function (h) { return fetch(base + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        ps = ps.filter(Boolean); if (!ps.length) return;
        $('[data-recent-grid]', sec).innerHTML = ps.map(cardHTML).join('');
        sec.hidden = false;
      });
  }
  function initRecs() {
    var rec = $('[data-recs]'); if (!rec) return;
    fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var sec = $('.recs', d); if (!sec) return;
      var g = rec.getAttribute('data-group');
      var items = $$('[data-group]', sec).filter(function (x) { return x.getAttribute('data-group') !== g; }).slice(0, 4);
      if (!items.length) return;
      var grid = $('[data-recs-grid]', sec); grid.innerHTML = ''; items.forEach(function (i) { grid.appendChild(i); });
      rec.parentNode.replaceChild(sec, rec);
    }).catch(function () {});
  }

  /* ---------- slideshow ---------- */
  function initHero(hero) {
    var slides = $$('[data-slide]', hero), dots = $$('[data-dot]', hero);
    if (!slides.length) return;
    var int = Number(hero.getAttribute('data-interval')) || 6000;
    hero.style.setProperty('--hero-int', int + 'ms');
    var i = 0, t = null, paused = false, left = int, start = 0;
    function light() { hero.classList.toggle('is-light', slides[i].getAttribute('data-ink') === 'light'); }
    function schedule(ms) { clearTimeout(t); left = ms; start = Date.now(); if (!paused && slides.length > 1) t = setTimeout(function () { show(i + 1); }, ms); }
    function show(n) {
      slides[i].classList.remove('is-on'); slides[i].setAttribute('aria-hidden', 'true'); if (dots[i]) dots[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on'); slides[i].setAttribute('aria-hidden', 'false');
      if (dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-on'); }
      light(); schedule(int);
    }
    hero.addEventListener('mouseenter', function () { if (!window.matchMedia('(hover: hover)').matches) return; paused = true; hero.classList.add('is-paused'); clearTimeout(t); left -= Date.now() - start; });
    hero.addEventListener('mouseleave', function () { if (!paused) return; paused = false; hero.classList.remove('is-paused'); schedule(Math.max(400, left)); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1)); x0 = null; });
    document.addEventListener('shopify:block:select', function (e) { var k = slides.indexOf(e.target); if (k > -1) { paused = true; show(k); clearTimeout(t); } });
    document.addEventListener('shopify:block:deselect', function () { paused = false; schedule(int); });
    light(); schedule(int);
  }
  function initSmiley(sm) {
    var base = sm.getAttribute('data-base') || '', speed = Number(sm.getAttribute('data-speed')) || 1400;
    var T = [['T01', 'black', '#111111'], ['T02', 'white', '#ffffff'], ['T03', 'blue', '#2454a6'], ['T04', 'green', '#1f9146'], ['T05', 'yellow', '#eee61b'], ['T06', 'red', '#e31e24']];
    var D = [['D01', 'red'], ['D02', 'blue'], ['D03', 'green'], ['D04', 'yellow'], ['D05', 'pink'], ['D06', 'orange'], ['D07', 'white'], ['D08', 'black']];
    var G = [['B01', '#e31e24'], ['B02', '#2454a6'], ['B03', '#1f9146'], ['B04', '#eee61b'], ['B05', '#ec5aa8'], ['B06', '#f0791e'], ['B07', '#ffffff'], ['B08', '#111111']];
    var pre = T.map(function (x) { return base + 'tee-' + x[1] + '.png'; }).concat(D.map(function (x) { return base + 'smile-' + x[1] + '.png'; })).map(function (u) { var im = new Image(); im.src = u; return im; });
    var tee = $('[data-sm-tee]', sm), face = $('[data-sm-face]', sm), circ = $('[data-sm-circle]', sm), code = $('[data-sm-code]', sm), hover = false;
    sm.addEventListener('mouseenter', function () { hover = true; }); sm.addEventListener('mouseleave', function () { hover = false; });
    function r(k) { return Math.floor(Math.random() * k); }
    setInterval(function () {
      var slide = sm.closest('[data-slide]');
      if (hover || document.hidden || (slide && !slide.classList.contains('is-on')) || pre.some(function (im) { return !im.complete; })) return;
      var t = T[r(6)], d = D[r(8)], b = G[r(8)];
      if (b[1] === t[2]) b = G[(G.indexOf(b) + 1) % 8];
      if (t[0] === 'T02' && b[0] === 'B07') b = G[0];
      if (d[1] === t[1]) d = D[(D.indexOf(d) + 3) % 8];
      tee.src = base + 'tee-' + t[1] + '.png'; face.src = base + 'smile-' + d[1] + '.png'; circ.style.background = b[1];
      if (code) code.textContent = t[0] + '\u2013' + d[0] + '\u2013' + b[0];
    }, speed);
  }

  /* ---------- countdowns, top bar ---------- */
  function initCountdown(el) {
    var at = Date.parse(el.getAttribute('data-countdown'));
    if (isNaN(at)) { el.hidden = true; return; }
    var U = [['DAYS', 86400], ['HRS', 3600], ['MIN', 60], ['SEC', 1]];
    el.innerHTML = U.map(function (u) { return '<div class="cd__u"><span class="cd__v">00</span><span class="cd__l">' + u[0] + '</span></div>'; }).join('');
    var vs = $$('.cd__v', el);
    function tick() { var s = Math.max(0, Math.floor((at - Date.now()) / 1000)); U.forEach(function (u, k) { var v = Math.floor(s / u[1]); s -= v * u[1]; vs[k].textContent = String(v).padStart(2, '0'); }); }
    tick(); setInterval(tick, 1000);
  }
  var ann = $('[data-ann-msg]'), clk = $('[data-clock]');
  function annTick() {
    var now = new Date();
    var hr = Number(now.toLocaleString('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: 'America/New_York' })) % 24;
    if (clk) clk.textContent = 'CIN ' + now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23', timeZone: 'America/New_York' });
    if (!ann) return;
    var msg = ann.getAttribute('data-default'), d = B.drop || {}, at = Date.parse(d.at);
    if (d.on && !isNaN(at) && at > now.getTime()) {
      var s = Math.floor((at - now.getTime()) / 1000), dd = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600; var m = Math.floor(s / 60); s %= 60;
      msg = (d.name || 'NEXT DROP') + ' DROPS IN ' + (dd ? dd + 'D ' : '') + [h, m, s].map(function (x) { return String(x).padStart(2, '0'); }).join(':');
    } else if (B.extras && B.extras.late && hr < 4 && ann.getAttribute('data-late')) msg = ann.getAttribute('data-late');
    if (ann.textContent !== msg) ann.textContent = msg;
  }

  /* ---------- search ---------- */
  function initSearch() {
    var si = $('[data-search-input]'), sr = $('[data-search-results]'), st = null;
    if (!si || !sr) return;
    si.addEventListener('input', function () {
      clearTimeout(st);
      var q = si.value.trim();
      if (q.length < 2) { sr.innerHTML = ''; return; }
      st = setTimeout(function () {
        var url = (R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (j) {
          var res = (j.resources && j.resources.results) || {}, P = res.products || [], O = (res.collections || []).concat(res.pages || []);
          if (!P.length && !O.length) { sr.innerHTML = '<p class="muted small" style="padding:18px 0">NOTHING MATCHES.</p>'; return; }
          sr.innerHTML = P.map(function (p) {
            var im = p.image || (p.featured_image && p.featured_image.url);
            var pr = typeof p.price === 'string' ? Math.round(parseFloat(p.price) * 100) : p.price;
            return '<a class="srch__row" href="' + p.url + '">' + (im ? '<img src="' + img(im, 120) + '" alt="">' : '<span class="ph"></span>') + '<span>' + esc(clean(p.title)) + '</span><span>' + money(pr) + '</span></a>';
          }).join('') + O.map(function (x) { return '<a class="srch__row" href="' + x.url + '"><span class="ph"></span><span>' + esc(x.title) + '</span><span class="muted">\u2192</span></a>'; }).join('') +
            '<a class="srch__all" href="' + (R.search || '/search') + '?type=product&q=' + encodeURIComponent(q) + '">SEE ALL RESULTS</a>';
        }).catch(function () {});
      }, 200);
    });
  }

  /* ---------- $10 pop-up ---------- */
  var pop = $('[data-popup]');
  function popOpen() { return pop && !pop.hidden; }
  function showPopup(force) {
    if (!pop) return;
    var seen = false; try { seen = !!localStorage.getItem('brkn_pop'); } catch (e) {}
    if (!force && (seen || openEl)) return;
    pop.hidden = false; document.body.classList.add('lock');
    var f = $('input[type=email]', pop) || $('[data-copy]', pop); if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function closePopup() {
    if (!popOpen()) return;
    pop.hidden = true; if (!openEl) document.body.classList.remove('lock');
    try { localStorage.setItem('brkn_pop', '1'); } catch (e) {}
  }
  function initPopup() {
    if (!pop) return;
    pop.addEventListener('click', function (e) { if (e.target === pop) closePopup(); });
    var code = $('[data-copy]', pop);
    if (code) code.addEventListener('click', function () {
      var v = code.getAttribute('data-v') || code.textContent.trim(); code.setAttribute('data-v', v);
      if (navigator.clipboard) navigator.clipboard.writeText(v);
      code.textContent = 'COPIED'; setTimeout(function () { code.textContent = v; }, 1200);
    });
    if ($('[data-pop-ok]', pop) && /customer_posted=true/.test(window.location.search)) { showPopup(true); return; }
    if (!(B.popup && B.popup.on) || B.tpl === 'cart' || B.tpl === 'password') return;
    var views = 1; try { views = Number(sessionStorage.getItem('brkn_pv') || 0) + 1; sessionStorage.setItem('brkn_pv', views); } catch (e) {}
    setTimeout(function () { showPopup(false); }, views >= 2 ? 1500 : (Number(B.popup.delay) || 8) * 1000);
  }

  /* ---------- password page ---------- */
  $$('[data-pw-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { var f = $('[data-pw]'); if (!f) return; f.hidden = !f.hidden; if (!f.hidden) { var i = $('input[type=password]', f); if (i) i.focus(); } });
  });

  /* ---------- console note ---------- */
  if (B.extras && B.extras.console) {
    try {
      console.log("%c\n    .--------.\n   /  o    o  \\\n  |            |\n  |  \\      /  |\n   \\  \u0060----\u0060  /\n    \u0060--------\u0060\n\n%cBRKNMRLS\n%c" + (B.extras.code ? 'You looked under the hood. Use ' + B.extras.code + ' for $10 off.' : 'You looked under the hood.'),
        'font-family:monospace;font-size:13px;line-height:1.1;', 'font:700 22px Helvetica Neue,Helvetica,Arial,sans-serif;letter-spacing:.04em;', 'font:13px Helvetica Neue,Helvetica,Arial,sans-serif;');
    } catch (e) {}
  }

  var egg = $('[data-egg]'), found = $('[data-egg-found]'), taps = 0, tapT = null;
  if (egg) egg.addEventListener('click', function () {
    egg.classList.add('is-egg'); clearTimeout(tapT); tapT = setTimeout(function () { egg.classList.remove('is-egg'); taps = 0; }, 1400);
    taps += 1; if (taps >= 5 && found) { found.hidden = false; taps = 0; }
  });

  /* Smiley ID product: live preview from dropdowns */
  function initSmPreview(pv) {
    var base = pv.getAttribute('data-base') || '', form = pv.closest('[data-pdp]') && pv.closest('[data-pdp]').querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var CIRC = { red: '#e31e24', blue: '#2454a6', green: '#1f9146', yellow: '#eee61b', pink: '#ec5aa8', orange: '#f0791e', white: '#ffffff', black: '#111111' };
    var tee = $('[data-sm-tee]', pv), face = $('[data-sm-face]', pv), circ = $('[data-sm-circle]', pv);
    function pick(rx) { var s = $$('select[name^="properties"]', form).filter(function (x) { return rx.test(x.name); })[0]; return s && s.value ? s.value.toLowerCase() : ''; }
    function upd() {
      var t = pick(/tee/i), f = pick(/smil/i), c = pick(/circle|background/i);
      if (t) tee.src = base + 'tee-' + t + '.png';
      if (f) face.src = base + 'smile-' + f + '.png';
      if (c && CIRC[c]) circ.style.background = CIRC[c];
    }
    form.addEventListener('change', upd); upd();
  }
  /* nudge rows: hide items already in the cart */
  function syncNudge(c) {
    var ids = (c && c.items || []).map(function (i) { return String(i.variant_id || i.id); });
    $$('[data-nudge] [data-quick-add]').forEach(function (b) { var row = b.closest('.nudge__row'); if (row) row.hidden = ids.indexOf(b.getAttribute('data-quick-add')) > -1; });
  }

  function init(root) {
    root = root || document;
    $$('[data-pdp]', root).forEach(initPDP);
    $$('[data-hero]', root).forEach(initHero);
    $$('[data-smiley]', root).forEach(initSmiley);
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-sm-preview]', root).forEach(initSmPreview);
  }
  init(document);
  initRecent(); initSearch(); initPopup();
  annTick(); setInterval(annTick, 1000);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
